import { MODULES } from "Helpers/Constants";
import { setAllStore } from "Helpers/setAllStore";
import moment from "moment";
import React, { useContext, useState } from "react";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import { getAccessByModuleName } from "Routes/Routes";
import { getCsrProductivityData } from "../../../api/report";
import ExportIcon from "../../../Assets/images/Export.svg";
import ReactTable from "../../../Components/Table/Table";
import Header from "../../../Components/Header/Header";
import { AppContext } from "../../../Context/AppContext";
// Components
import styles from "./index.module.scss";
import GlobalDateFilters from "Components/GlobalDateFilters/GlobalDateFilters";

const OfficeProductivity = () => {
  const { showToastMessage, modules } = useContext(AppContext);
  const navigate = useNavigate();
  // Add / Edit
  let accessExport = getAccessByModuleName(
    modules,
    MODULES.OFFICE_PRODUCTIVITY_REPORT
  );

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(1);
  const reference = React.useRef(null);

  const [defaultFilter, setDefaultFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    filters: [],
    globalFilter: "",
  });

  const [fromDate, setFromDate] = useState(
    moment().startOf("week").format("ddd MMM DD, YYYY")
  );
  const [toDate, setToDate] = useState(
    moment().endOf("week").format("ddd MMM DD, YYYY")
  );
  const [selectedPeriod, setSelectedPeriod] = React.useState("weekly");
  const [selectedPeriodLabel, setSelectedPeriodLabel] =
    React.useState("By Week");

  const [exportData, setExportData] = React.useState([]);
  const [exportHeader, setExportHeader] = React.useState([]);

  const [checkAllStore, setCheckAllStore] = useState(true);

  const fetchData = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
    fromDateDefault,
    toDateDefault,
    selectedPeriodDefault,
  }) => {
    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
    setAllStore(checkAllStore);

    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy });
    setLoading(true);

    const postData = {
      currentPage: pageIndex,
      itemsPerPage: pageSize,
      globalSearch: globalFilter,
      filters,
      sortBy,
      start_date: fromDateDefault ?? moment(fromDate).format("YYYY-MM-DD"),
      end_date: toDateDefault ?? moment(toDate).format("YYYY-MM-DD"),
    };

    const response = await getCsrProductivityData(postData);
    if (response && response.status === 200) {
      const updatedResponse = [];
      response.data.data.rows.map((data) => {
        data = { ...data, ...data["clock_time_masters"] };
        delete data["clock_time_masters"];
        updatedResponse.push(data);
      });
      setData(updatedResponse ?? []);
      setPageCount(Math.ceil(response.data.data.count.length / pageSize));
    } else if (response.status === 403) {
      showToastMessage(undefined, response.data.message, "error", false);
      navigate("/profile");
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }

    setLoading(false);

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if (checkAllStore) {
      setAllStore(false);
    }
  };

  const handleClearSearch = async (event) => {
    event.preventDefault();
    setFromDate(moment().startOf("week").format("ddd MMM DD, YYYY"));
    setToDate(moment().endOf("week").format("ddd MMM DD, YYYY"));
    setSelectedPeriod("weekly");
    fetchData({
      ...defaultFilter,
      fromDateDefault: moment().startOf("week").format("YYYY-MM-DD"),
      toDateDefault: moment().endOf("week").format("YYYY-MM-DD"),
      selectedPeriodDefault: "weekly",
    });
    // handleExportProductivity(
    //   event.pageIndex,
    //   event.pageSize,
    //   event.globalFilter
  };

  const handleExportProductivity = async (
    sortBy,
    filters,
    fromDateDefault,
    toDateDefault
  ) => {
    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
    setAllStore(checkAllStore);

    let postData = {
      isExport: true,
      filters,
      sortBy,
      start_date: fromDateDefault ?? moment(fromDate).format("YYYY-MM-DD"),
      end_date: toDateDefault ?? moment(toDate).format("YYYY-MM-DD"),
    };

    const response = await getCsrProductivityData(postData);
    if (response && response.status === 200) {
      const updatedResponse = [];
      response.data.data.data.rows.map((data) => {
        data = { ...data, ...data["clock_time_masters"] };
        delete data["clock_time_masters"];
        updatedResponse.push(data);
      });

      setExportHeader(response.data.data.header);
      setExportData(updatedResponse);
      reference.current?.link?.click();
    } else if (response.status === 403) {
      showToastMessage(undefined, response.data.message, "error", false);
      navigate("/profile");
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if (checkAllStore) {
      setAllStore(false);
    }
  };

  //     setFromDate(moment().startOf("week").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("week").format("ddd MMM DD, YYYY"));
  //     setFromDate(moment().startOf("month").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("month").format("ddd MMM DD, YYYY"));
  //     setFromDate(moment().startOf("year").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("year").format("ddd MMM DD, YYYY"));

  //     setToDate(moment(data).add(7, "days").utc().format("ddd MMM DD, YYYY"));
  //     setToDate(moment(data).add(1, "months").utc().format("ddd MMM DD, YYYY"));
  //     setToDate(moment(data).add(1, "years").utc().format("ddd MMM DD, YYYY"));

  //     setFromDate(
  //       moment(data).subtract(7, "days").utc().format("ddd MMM DD, YYYY")
  //     setFromDate(
  //       moment(data).subtract(1, "months").utc().format("ddd MMM DD, YYYY")
  //     setFromDate(
  //       moment(data).subtract(1, "years").utc().format("ddd MMM DD, YYYY")

  const columns = React.useMemo(() => [
    {
      Header: "Sales Representative",
      accessor: (data) => `${data.first_name} ${data.last_name}`,
      isVisible: true,
    },
    {
      Header: "Regular Hours",
      accessor: "totalRegularHours",
      isVisible: true,
      disableSortBy: true,
      disableFilters: true,
    },
    {
      Header: "Overtime",
      accessor: "totalOt",
      isVisible: true,
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: "Double Overtime",
      accessor: "totalDot",
      isVisible: true,
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: "Total Hours",
      accessor: "totalHours",
      isVisible: true,
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: "Create",
      accessor: "create",
      isVisible: true,
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: "Update",
      accessor: "update",
      isVisible: true,
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: "Create per hour",
      accessor: "create_per_hour",
      isVisible: true,
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: "Update per hour",
      accessor: "update_per_hour",
      isVisible: true,
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: "Average Order Value",
      accessor: "avg_order_value",
      isVisible: true,
      disableFilters: true,
      disableSortBy: true,
    },
  ]);

  const selectedPeriodOptions = [
    { id: "weekly", title: "Weekly", label: "By Week" },
    { id: "monthly", title: "Monthly", label: "By Month" },
    { id: "yearly", title: "Yearly", label: "By Year" },
    { id: "custom", title: "Custom", label: "Custom" },
  ];
  return (
    <React.Fragment>
      <Header title="Office Productivity Report" />
      <div id="MainContent" className="main-content" />

      <div className={"row d-flex d-flex align-items-end"}>
        <div className="col-11 m-0 p-0">
          <GlobalDateFilters
            isDateFilter
            isSearchIcon
            isClearSearchBtn
            isAllCheckStoreBnt
            isFilterByPeriod
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            fetchData={()=>fetchData({
              ...defaultFilter
            })}
            handleClearSearch={handleClearSearch}

            checkAllStore={(data)=>{setCheckAllStore(data)}}
            defaultSetCheckAllStore={checkAllStore}
            selectedPeriod={selectedPeriod}
            setSelectedPeriod={setSelectedPeriod}
            periodOptions={selectedPeriodOptions}
            isSelectedPeriodLabel
            selectedPeriodLabel={selectedPeriodLabel}
            setSelectedPeriodLabel={setSelectedPeriodLabel}
            key={"office-productivity-report"}
          />
        </div>
        <div className="col-1 mb-4">
          <div className="mb-3 d-flex justify-content-end">
            {exportData && exportData.length > 0 && (
                <CSVLink
                  ref={reference}
                  style={{
                  display: "none",
                  float: "right",
                  marginTop: "25px",
                }}
                data={exportData}
                headers={exportHeader}
                filename={"OfficeProductivityReport.csv"}
                className={`link cursor-pointer ml-3 ${styles.searchIconWrapper}`}
              >
                DownLoad
              </CSVLink>
            )}
            {accessExport && accessExport.permissions.write_access && (
              <span
                onClick={(e) => handleExportProductivity(defaultFilter)}
                className={`link cursor-pointer ${styles.searchIconWrapper}`}
                style={{ float: "right" }}
              >
                <img
                  className={styles.searchIcon}
                  src={ExportIcon}
                  alt="Export Data"
                />
              </span>
            )}
          </div>
        </div>
      </div>
      <br></br>
      <br></br>
      <div>
        <ReactTable
          columns={columns}
          data={data}
          fetchData={fetchData}
          loading={loading}
          pageCount={pageCount}
          noDataText={"There is no data to display"}
          defaultFilter={defaultFilter}
          displayGlobalSearch={false}
          displayColumnVisibility={false}
        />
      </div>
    </React.Fragment>
  );
};

export default OfficeProductivity;
